import React from 'react';
import { Box, Link, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(3.25, 2, 3),
    color: '#7f7f7f',
    [theme.breakpoints.up('sm')]: { padding: theme.spacing(3.25, 4, 3) },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      height: '72px',
      padding: theme.spacing(0, 4),
    },
  },

  nav: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(-1),
    [theme.breakpoints.up('sm')]: { flexFlow: 'row wrap' },
    [theme.breakpoints.up('lg')]: { margin: 'auto 0' },
  },
  links: {
    color: '#636363',
    fontSize: '14px',
    lineHeight: '21px',
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    padding: theme.spacing(1),
    display: 'inline-block',
    [theme.breakpoints.up('sm')]: { marginRight: theme.spacing(1) },
    [theme.breakpoints.up('lg')]: { padding: 0, marginRight: theme.spacing(3) },
    '&:last-child': { marginRight: 0 },
    '&:link': { color: '#7f7f7f' },
    '&:visited': { color: '#7f7f7f' },
    '&:action': { color: '#333333', textDecoration: 'underline' },
    '&:focus': { color: '#333333', textDecoration: 'underline' },
    '&:hover': { color: '#333333', textDecoration: 'underline' },
  },
  copyright: {
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    margin: theme.spacing(4, 'auto', 0),
    [theme.breakpoints.up('lg')]: {
      display: 'inline-block',
      textAlign: 'right',
      margin: theme.spacing('auto', 0, 'auto', 'auto'),
    },
  },
}));

export interface FooterProps {
  className?: string;
}

const Component: React.FC<FooterProps> = ({ className }) => {
  const classes = useStyle();

  const links = [
    { href: '/terms?from=workflow', str: '利用規約' },
    {
      href: 'https://www.worksap.co.jp/services/spec/wf-spec/',
      str: 'Workfrowサービス仕様書',
    },
    {
      href: '/workflow/trial-spec',
      str: 'Workflowトライアルサービス仕様書',
      component: RouterLink,
    },
    {
      href: '/privacy?from=workflow',
      str: '個人情報の取扱いについて',
    },
    {
      href: '/law?from=workflow',
      str: '特定商取引法に基づく表記',
    },
    { href: 'https://www.worksap.co.jp/about/', str: '会社概要' },
  ];

  return (
    <Box component="footer" className={`${classes.root} ${className ?? ''}`}>
      <Box component="nav" className={classes.nav}>
        {links.map((v) => {
          return v.component ? (
            <Link
              component={v.component}
              to={v.href}
              className={classes.links}
              rel={'noreferrer'}
              key={v.href}
            >
              {v.str}
            </Link>
          ) : (
            <Link
              href={v.href}
              className={classes.links}
              rel={'noreferrer'}
              key={v.href}
            >
              {v.str}
            </Link>
          );
        })}
      </Box>
      <Box component="p" className={classes.copyright}>
        &copy;2023&nbsp;Works&nbsp;Applications&nbsp;Co.,&nbsp;Ltd.
      </Box>
    </Box>
  );
};

export const Footer = React.memo(Component);
